import { SVGFont } from "./svg-font";
export default SVGFont;